import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bb9732f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-20 md:mt-9" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "relative flex flex-col flex-grow items-start p-4 h-full text-primary text-left bg-white lg:p-8" }
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = {
  key: 0,
  class: "text-secondary line-clamp-3 mb-6"
}
const _hoisted_6 = { class: "inline-flex items-center self-start mt-auto px-4 h-11 text-white bg-secondary rounded" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "relative p-4 text-dark bg-white lg:p-8"
}
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = {
  key: 0,
  class: "mb-4 text-secondary leading-normal lg:mb-8"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timeline_filter = _resolveComponent("timeline-filter")!
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_modal = _resolveComponent("ui-modal")!
  const _component_ContentWideLayout = _resolveComponent("ContentWideLayout")!

  return (_openBlock(), _createBlock(_component_ContentWideLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_timeline_filter),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.filteredMemories), (item, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: _ctx.rt(item[0].title) + index,
            type: "button",
            class: "group relative flex bg-white shadow-xl md:bg-transparent",
            onClick: 
                    () => {
                        _ctx.activeItem = item;
                        _ctx.activeIndex = index;
                        _ctx.setModal('memoryItem');
                    }
                
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.rt(item[0].title)), 1),
              (item[0].job_title)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.rt(item[0].job_title)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", _hoisted_6, _toDisplayString(_ctx.t('read_more')), 1)
            ])
          ], 8, _hoisted_2))
        }), 128))
      ]),
      (_ctx.modalName === 'memoryItem')
        ? (_openBlock(), _createBlock(_component_ui_modal, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: _normalizeClass([
                        { disabled: _ctx.activeIndex === 0 },
                        'modal-navigation rounded-tl rounded-bl',
                    ]),
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeActiveModalItem(-1)))
                }, [
                  _createVNode(_component_ui_icon, { name: "arrow-left" })
                ], 2),
                (_ctx.activeItem)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.rt(_ctx.activeItem[0].title)), 1),
                      (_ctx.activeItem[0].job_title)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(_ctx.rt(_ctx.activeItem[0].job_title)), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeItem, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.title,
                          class: "mb-8 last:mb-0"
                        }, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.rt(item.subtitle)), 1),
                            _hoisted_11,
                            _createElementVNode("span", {
                              innerHTML: _ctx.rt(item.text)
                            }, null, 8, _hoisted_12)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: _normalizeClass([
                        {
                            disabled: _ctx.activeIndex === Object.values(_ctx.filteredMemories).length - 1,
                        },
                        'modal-navigation rounded-tr rounded-br',
                    ]),
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeActiveModalItem(+1)))
                }, [
                  _createVNode(_component_ui_icon, { name: "arrow-right" })
                ], 2)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}